import InputLabel from './InputLabel';
import './InputLabel.scss';

export default InputLabel;
